import { ExternalApp } from '@column/api';

export type ExternalAppMode = ExternalApp['modes'][number];

export const getExternalAppURL = (app: ExternalApp) => {
  if (!app.address) {
    return undefined;
  }

  if (/^[a-z][a-z\d+\-.]*:\/\//i.test(app.address)) {
    return app.address;
  }

  return `https://${app.address}`;
};

export const getExternalAppRedirectSlug = (appRedirect: string | null) => {
  const value = appRedirect?.trim();
  if (!value) {
    return undefined;
  }

  const withoutProtocol = value.replace(/^[a-z][a-z\d+\-.]*:\/\//i, '');
  const host = withoutProtocol.split('/')[0]?.split('?')[0]?.split('#')[0] ?? '';
  return host.split('.')[0] || undefined;
};

export const getExternalAppRedirectURL = (app: ExternalApp, appRedirect: string | null) => {
  const appURL = getExternalAppURL(app);
  const value = appRedirect?.trim();
  if (!appURL || !value) {
    return appURL;
  }

  const parseRedirectURL = () => {
    if (/^[a-z][a-z\d+\-.]*:\/\//i.test(value)) {
      return new URL(value);
    }

    if (value.startsWith('/') || value.startsWith('?') || value.startsWith('#')) {
      return new URL(value, appURL);
    }

    const host = value.split('/')[0]?.split('?')[0]?.split('#')[0] ?? '';
    if (host.includes('.')) {
      return new URL(`https://${value}`);
    }

    return undefined;
  };

  try {
    const redirectURL = parseRedirectURL();
    if (!redirectURL) {
      return appURL;
    }

    const destinationURL = new URL(appURL);
    destinationURL.pathname = redirectURL.pathname;
    destinationURL.search = redirectURL.search;
    destinationURL.hash = redirectURL.hash;
    return destinationURL.toString();
  } catch {
    return appURL;
  }
};

export const getTargetMode = (modes: ExternalAppMode[], isSandbox?: boolean) => {
  const currentMode: ExternalAppMode = isSandbox ? 'sandbox' : 'live';
  if (modes.includes(currentMode)) {
    return currentMode;
  }
  if (modes.includes('live')) {
    return 'live';
  }
  if (modes.includes('sandbox')) {
    return 'sandbox';
  }
  return undefined;
};
